import React from "react";
import classNames from "classnames";
import styles from "./static/dot.module.css";

const Dot = (props: any) => {
  return <div className={classNames(styles.dot, props.root)}></div>;
};

export default Dot;
